import React from 'react'
import { useState } from 'react';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import { Translate } from 'react-bootstrap-icons'; 
import './NavBar.css'

const NavBar = () => {
    
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const animateBars = () => {
        setMenuOpen(!isMenuOpen);
    };

    const toggleSideBar = () => {
        setSidebarOpen(!isSidebarOpen);
    }

    const handleScrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
        setMenuOpen(false);
        setSidebarOpen(false);
      };


  return (
    <header>
        <nav id='navbar'>
        {/* //Button */}
        <button className={`menu ${isMenuOpen ? 'active' : ''}`} onClick={() => { animateBars(); toggleSideBar(); }}>
                    <span className={`l1 ${isMenuOpen ? 'activel1' : ''}`} id='l1'></span>
                    <span className={`l2 ${isMenuOpen ? 'activel2' : ''}`} id='l2'></span>
                    <span className={`l3 ${isMenuOpen ? 'activel3' : ''}`} id='l3'></span>
                </button>

{/* opciones */}
            <div className={`options_container ${isSidebarOpen ? 'active' : ''}`} id='options_container'>
                <ul>
                    <li className='navLi'onClick={() => handleScrollToSection('about-me')}>
                        Sobre mi
                    </li>
                    <li className='navLi'onClick={() => handleScrollToSection('skills')}>
                        Habilidades
                    </li>
                    <li className='navLi'onClick={() => handleScrollToSection('projects')}>
                        Proyectos
                    </li>
                    <li className='navLi'onClick={() => handleScrollToSection('experience')}>
                                Experiencia
                    </li>
                    <li className='navLi' onClick={() => handleScrollToSection('contact')}>
                        Contacto
                    </li>
                </ul>
            </div>

{/* traduccion y color */}
            <div className="options2_container" id='options2_container'>
                    <ul>
                        <li ><Translate className='translation' title='Switch to English' /></li>
                        <li id='switcher' title='Cambiar tema'><ToggleSwitch/></li>
                    </ul>
            </div>
        </nav>
    </header>

    )
}

export default NavBar